import { useMutation } from '@tanstack/react-query';
import {
  invalidateUnreadRequests,
  markRequestAsRead,
} from '../../services/appointments';

function useMarkRequestAsRead() {
  return useMutation({
    mutationFn: async ({
      requestId,
      type,
    }: {
      requestId: string;
      type: 'appointment' | 'generalRequest';
    }) => {
      const result = await markRequestAsRead(requestId, type);
      await invalidateUnreadRequests();
      return result;
    },
  });
}

export default useMarkRequestAsRead;
